var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn--ghost-primary icon icon--left u-margin-top-0",on:{"click":_vm.goBack}},[_c('i',{staticClass:"icon-back"}),_vm._v(" "+_vm._s(_vm.$t('common.back'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }